import { PropertyValueType } from "../../../../concepts/objects";


export const DimensionsType: PropertyValueType<[number, number]> = Object.freeze({
    name: 'Dimensions',
    fromString(value: string): [boolean, [number, number]] {
        const [cols, rows] = value.split(',') ?? [];
        const result = [parseInt(cols ?? '') || 1, parseInt(rows ?? '') || 1] as [number, number];
        return [true, result];
    },
    serialize(value: [number, number]): [number, number] {
        if (typeof (value) === 'string') {
            return DimensionsType.fromString(value)[1];
        };
        const cols = Math.max(1, Array.isArray(value) ? value[0] : 1);
        const rows = Math.max(1, Array.isArray(value) ? value[1] : 1);
        return [cols, rows];
    },
    deserialize(value: any, defau1t?: [number, number]): [number, number] {
        if (!value) return defau1t;
        return DimensionsType.serialize(value);
    },
});
